import * as api from 'config/axios';
import * as endpoints from './endpoints';

export const disableChargeWarning = () => {
  return api.sendPost(endpoints.DISABLE_CHARGE_WARNING);
};

export const getUserCardEula = () => {
  return api.sendGet(endpoints.GET_USER_CREDIT_CARD_EULA);
};

export const acceptCardEula = (params) => {
  return api.sendPost(endpoints.ACCEPT_CARD_EULA, params);
};
export const rejectCardEula = (params) => {
  return api.sendPost(endpoints.REJECT_CARD_EULA, params);
};

export const getLinkIframeCard = (params) => {
  return api.sendPost(endpoints.GET_LINK_IFRAME_CARD, params);
};

export const communicatorIframe = () => {
  return api.sendGet(endpoints.IFRAME_COMMUNICATOR);
};

export const syncSavedMemberCard = (params) => {
  return api.sendGet(endpoints.SYNC_SAVED_MEMBER_CARD, { params });
};

export const getSavedMemberCard = (params) => {
  return api.sendGet(endpoints.GET_SAVED_MEMBER_CARD, { params });
};

export const removeSavedMemberCard = (params) => {
  return api.sendPost(endpoints.REMOVE_SAVED_CARD, params);
};

export const getLinkIframeEditedCard = (params) => {
  return api.sendPost(endpoints.GET_LINK_IFRAME_EDITED_CARD, params);
};

export const getMemberBillingProperties = (params) => {
  return api.sendGet(endpoints.GET_MEMBER_BILLING_PROPERTIES, { params });
};

export const saveMemberBillingProperties = (params) => {
  return api.sendPost(endpoints.SAVE_MEMBER_BILLING_PROPERTIES, params);
};

export const editMemberPaymentSetting = (params) => {
  return api.sendPost(endpoints.EDIT_MEMBER_PAYMENT_SETTING, params);
};

export const getMemberBillingStatements = (params) => {
  return api.sendPost(endpoints.GET_MEMBER_BILLING_STATEMENTS, params);
};

export const addCharge = (params) => {
  return api.sendPost(endpoints.ADD_CHARGE, params);
};

export const downloadBillingStatement = (params) => {
  return api.requestToDownload({
    method: 'post',
    apiEndpoint: endpoints.DOWNLOAD_BILLING_STATEMENT,
    payload: params,
  });
};

export const exportBillingStatement = (params) => {
  return api.requestToDownload({
    method: 'post',
    apiEndpoint: endpoints.EXPORT_BILLING_STATEMENT,
    payload: params,
  });
};

export const getAuthorizedCardUsers = (params) => {
  return api.sendPost(endpoints.GET_AUTHORIZED_CARD_USERS, params);
};

export const saveAuthorizedCardUser = (params) => {
  return api.sendPost(endpoints.SAVE_AUTHORIZED_CARD_USER, params);
};

export const removeAuthorizedCardUsers = (params) => {
  return api.sendPost(endpoints.REMOVE_AUTHORIZED_CARD_USER, params);
};

export const downloadBillingReceipt = (params) => {
  return api.requestToDownload({
    method: 'post',
    apiEndpoint: endpoints.DOWNLOAD_BILLING_RECEIPT,
    payload: params,
  });
};

export const addBillingNote = (params) => {
  return api.sendPost(endpoints.ADD_BILLING_NOTE, params);
};

export const getBillingNote = (params) => {
  return api.sendPost(endpoints.GET_BILLING_NOTE_GRID, params);
};

export const getMemberBillingChargeDetail = (params) => {
  return api.sendGet(endpoints.GET_MEMBER_BILLING_CHARGE_DETAIL, { params });
};

export const getMemberDiscountProperties = (params) => {
  return api.sendGet(endpoints.GET_MEMBER_DISCOUNT_PROPERTIES, { params });
};

export const saveMemberDiscountProperties = (params) => {
  return api.sendPost(endpoints.SAVE_MEMBER_DISCOUNT_PROPERTIES, params);
};

export const getMemberBillingSetupProperties = (params) => {
  return api.sendGet(endpoints.GET_MEMBER_BILLING_SETUP_PROPERTIES, { params });
};

export const saveMemberBillingSetupProperties = (params) => {
  return api.sendPost(endpoints.SAVE_MEMBER_BILLING_SETUP_PROPERTIES, params);
};
